export default __webpack_public_path__ + "static/media/OEM.cf41b7e9.svg";